/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  useInfiniteHomepassAdditional,
  useInfiniteHomepassInvalid,
} from "@/api/rfs";
import { useEffect, useMemo } from "react";

export default function useHomepassData({
  apdId,
  gapHp,
  isInvalid,
  open,
}: {
  apdId: string;
  gapHp: string;
  isInvalid: boolean;
  open: boolean;
}) {
  const {
    data: invalids,
    hasNextPage: hasNextPageInvalids,
    fetchNextPage: fetchNextInvalids,
    isFetchingNextPage: isFetchingNextPageInvalids,
  } = useInfiniteHomepassInvalid(
    { apdId, gapHp },
    {
      enable: isInvalid === true && open,
    },
  );
  const {
    data: additionals,
    hasNextPage: hasNextPageAdditionals,
    fetchNextPage: fetchNextAdditionals,
    isFetchingNextPage: isFetchingNextPageAdditionals,
  } = useInfiniteHomepassAdditional(
    {
      apdId,
      gapHp,
    },
    {
      enable: isInvalid === false && open,
    },
  );

  // Fetch all pages for invalids
  useEffect(() => {
    if (hasNextPageInvalids && !isFetchingNextPageInvalids) {
      fetchNextInvalids();
    }
  }, [
    hasNextPageInvalids,
    isFetchingNextPageInvalids,
    open,
    fetchNextInvalids,
  ]);

  // Fetch all pages for additionals
  useEffect(() => {
    if (hasNextPageAdditionals && !isFetchingNextPageAdditionals) {
      fetchNextAdditionals();
    }
  }, [
    hasNextPageAdditionals,
    isFetchingNextPageAdditionals,
    open,
    fetchNextAdditionals,
  ]);

  // Memoize flattened data to avoid unnecessary recalculations
  const invalidsRef = useMemo(
    () => invalids?.pages.flatMap((page) => page.content) ?? [],
    [invalids?.pages],
  );

  const additionalsRef = useMemo(
    () => additionals?.pages.flatMap((page) => page.content) ?? [],
    [additionals?.pages],
  );

  return { invalidsRef, additionalsRef };
}
